export default {
  styleOverrides: {
    select: {
      minHeight: '1.1876em',
    },
  },
};
